import { render, staticRenderFns } from "./FlowBuilder.vue?vue&type=template&id=6f704ead&scoped=true&"
import script from "./FlowBuilder.vue?vue&type=script&lang=js&"
export * from "./FlowBuilder.vue?vue&type=script&lang=js&"
import style0 from "./FlowBuilder.vue?vue&type=style&index=0&id=6f704ead&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f704ead",
  null
  
)

export default component.exports